export const driveBase = '';

// Ids fixos dos programas (ver database/seeders/Programa.ts no backend, que roda em
// todos os ambientes e sempre faz upsert por esse id exato). Usar esses ids em vez de
// comparar Programa.nome: o nome pode ser editado livremente, o id não.
export const PROGRAMA_ID = {
  MAF: 1,
  PROCEL: 2,
  NOVO_B_MAIS_P: 3,
  MAF_140H: 8
};

// Valor de user.uf pra "Todos os estados" (Config/estados.ts UF_TODOS no backend) - só
// oferecido no cadastro de usuário do admin, nunca nas telas públicas.
export const UF_TODOS = "TODOS";

export const errorMessages = {
  E_INVALID_AUTH_PASSWORD: 'Senha inválida',
  E_INVALID_AUTH_UID: 'Usuário não encontrado',
  E_INVALID_CREDENTIAL: 'Senha inválida',
  ER_DUP_ENTRY: 'Cadastro duplicado',
  E_ROW_NOT_FOUND: 'Cadastro não encontrado',
  E_UNAUTHORIZED_ACCESS: 'Acesso não autorizado'
};

export const materialTableLocalization = {
  body: {
    emptyDataSourceMessage: 'Nenhum registro para exibir'
  },
  toolbar: {
    searchTooltip: 'Pesquisar'
  },
  header: {
    actions: 'Ações'
  },
  pagination: {
    labelRowsSelect: 'linhas',
    labelDisplayedRows: '{count} de {from}-{to}',
    labelRowsPerPage: 'Linhas por página:',
    firstTooltip: 'Primeira página',
    previousTooltip: 'Página anterior',
    nextTooltip: 'Próxima página',
    lastTooltip: 'Última página'
  }
};

export const materialTableCurrencySettings = {
  locale: 'pt-BR',
  currencyCode:'BRL',
  minimumFractionDigits:2,
  maximumFractionDigits:2
};

export const indGeraisCfg = {
  investEur: 80,
  numImpl: 425,
  numDiags: 1000,
  econEnergia: 7.267,
  reducaoCO2: 1.1
};
